export default __webpack_public_path__ + "static/O0155-78ce7e37f4b682980b7619faa15b6fdf.png";